import { FormEvent, ReactNode } from "react"
import { useForm } from '@inertiajs/react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { Input } from "../components/ui/input"
import { Label } from "../components/ui/label"
import Layout from "../layouts/Layout"
// import { useToast } from "../hooks/use-toast"
import { Lock } from "lucide-react"
import { Head } from "@inertiajs/react"

const AdminLogin = () => {
  const {post, data, setData, processing, reset} = useForm({
    email_address: '',
    password: '',
  })

  // const { toast } = useToast()

  const handleSubmit = (ev: FormEvent) => {
    ev.preventDefault()

    post('/admin/session')
  }

  return (
    <>
      <Head title="Codeware - Admin Login" >
        <meta name="description" content="Login to the Codeware admin dashboard." />
      </Head>
      <div className="min-h-auto flex items-center justify-center bg-gradient-to-br from-background to-muted/20 px-4 py-12">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="p-3 bg-primary/10 rounded-full">
                <Lock className="h-6 w-6 text-primary" />
              </div>
            </div>
            <CardTitle className="text-2xl">Admin Login</CardTitle>
            <CardDescription>
              Access the Codeware admin dashboard
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={data.email_address}
                  onChange={(e) => setData('email_address', e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  value={data.password}
                  onChange={(e) => setData('password', e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Logging in..." : "Login"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

AdminLogin.layout = (page: ReactNode) => <Layout>{page}</Layout>

export default AdminLogin
